/* eslint-disable max-len */
import React, { useState } from 'react';
import styled from 'styled-components';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { useSubmitter } from '../../platform/Hook';
import { Grid, Select, Toggle } from '../../ui';
import { ResultInfoForSubmitter } from '../../ui/ResultInfo';
import { useResolve } from '../Container';
import { Copy, Flexer, Title } from '../dashboard/elements/LayoutElements';
import { PreferencesModel } from '../preferences/PreferencesModel';

const OptionInfo = styled.div`
    display: inline-block;
    padding-right: 2rem;
    margin-right: 2rem;

    ${Title} {
        margin-bottom: .5rem;
        font-size: 1rem;
    }
    ${Copy} {
        margin: 0;
        font-size: .875rem;
    }
`;

const OptionControl = styled.div`
    display: inline-block;
    width: 10rem;
    display: flex;
    align-items: center;

    ${Select.Frame} {
        width: 100%;
    }
`;

export type ShowDontShowOption = { key: boolean, label: string };
export const ShowDontShowOption = {
    all: [
        { key: true, label: 'Show' } as ShowDontShowOption,
        { key: false, label: 'Don\'t Show' } as ShowDontShowOption,
    ],
    for: (value: boolean) => ShowDontShowOption.all.find(x => x.key === value),
};

export const PromptsView = () => {

    const api = useResolve(ApiClient);
    const preferences = useResolve(PreferencesModel);
    const [state, setState] = useState(preferences.getState());

    const [onSubmit, _working, result] = useSubmitter(async (patch: Partial<typeof state>) => {
        const before = Object.fromEntries(Object.keys(patch).map(x => [x, state[x]]));
        setState(x => ({ ...x, ...patch }));
        try {
            await api.exec(v2.me.preferences.update(patch));
        }
        catch (e) {
            setState(x => ({ ...x, ...before }));
            throw e;
        }
    }, [state]);

    return <Flexer width="42">
        <Grid columns="auto 10rem" columnGap="1rem" rowGap="2rem">
            <OptionInfo>
                <Title>Choose Mode Popup </Title>
                <Copy>
                    Controls whether or not to show the Choose Editor Mode popup that appears when you open a new board from a template.
                </Copy>
            </OptionInfo>
            <OptionControl>
                <Select
                    items={ShowDontShowOption.all}
                    selected={ShowDontShowOption.for(state.editorModePopup)}
                    onChange={x => onSubmit({ editorModePopup: x.key })} />
            </OptionControl>
            <OptionInfo>
                <Title>Legacy Boards</Title>
                <Copy>
                    Controls whether or not the Legacy Boards view is available in the navigation.  This won't affect users without V1 boards.
                </Copy>
            </OptionInfo>
            <OptionControl>
                <Toggle value={state.legacyBoards} onAction={x => onSubmit({ legacyBoards: x })} />
            </OptionControl>
            <OptionInfo>
                <Title>Help As You Go </Title>
                <Copy>
                    Enables or disables the Help As You Go feature that shows you tips as you use the application.
                </Copy>
            </OptionInfo>
            <OptionControl>
                <Toggle value={state.haug} onAction={x => onSubmit({ haug: x })} />
            </OptionControl>
            {/* <OptionInfo>
                <Title>Reset Help Popups</Title>
                <Copy>
                    Controls how the application detects your mouse type.
                    This affects how the zooming works. <Em>Auto</Em> will try and guess,
                    if you are having issues set this manually to the device you are using.
                </Copy>
            </OptionInfo> */}
        </Grid>
        <Flexer margin="2 0">
            <ResultInfoForSubmitter result={result} onSuccess="Changes saved." />
        </Flexer>
    </Flexer>;
};
